module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Bath-ceae6f30c463946e95ef7f075f472fdf.svg";